import * as React from "react";

interface DisplayProps {
    children: any;
    isVisible: boolean | any;
}

export const Display: React.FC<DisplayProps> = (props) => {
    if (!props.isVisible) {
        return null;
    }
    return (
        <>
            {typeof props.children === 'function'
                ? props.children()
                : props.children
            }
        </>
    );
}